import {
    useQuery,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

type FailedData = Record<string, string>;

export type UploadedFileT = {
    name: string;
    uploadDate: string;
    uploadStatus: string;
    failedData: Array<FailedData>;
};

/**
 * Get the list of uploaded files for a given table.
 */
export const useUploadedFiles = (
    tableName: string | null,
    params: Pick<
        UseQueryOptions<UploadedFileT, HttpError>,
        'enabled' | 'refetchInterval'
    >,
): UseQueryResult<UploadedFileT, HttpError> =>
    useQuery({
        queryKey: ['getUploadedFiles', tableName || ''],
        queryFn: async () => {
            const response = await RQAPICallWithData<UploadedFileT>({
                method: 'GET',
                endpoint: `extractors/uploaded_file/${tableName}/last`,
            });
            return response.content.data;
        },
        refetchOnWindowFocus: false,
        ...params,
    });
